export default "__VITE_ASSET__Blvghgy8__"